import { FaTh, FaSearch, FaDraftingCompass, FaShieldAlt } from 'react-icons/fa';

const features = [
    {
        id: 1,
        icon: <FaTh />, // Material Selection icon
        title: 'Material Selection',
        description: 'Offering a wide range of roofing materials including asphalt shingles, metal, and tile.',
    },
    {
        id: 2,
        icon: <FaSearch />, // Roof Inspection icon
        title: 'Roof Inspection',
        description: 'Conducting thorough inspections to identify potential issues and provide accurate assessments.',
    },
    {
        id: 3,
        icon: <FaDraftingCompass />, // Custom Roofing Designs icon
        title: 'Custom Roofing Designs',
        description: 'Creating bespoke roofing designs tailored to your specific aesthetic and functional needs.',
    },
    {
        id: 4,
        icon: <FaShieldAlt />, // Durability Assurance icon
        title: 'Durability Assurance',
        description: 'Guaranteeing long-lasting durability and protection with our top-quality roofing solutions.',
    },
];

export default features;